module.exports = __webpack_public_path__ + "static/media/schooling.6f794ee2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/schooling.jpg
// module id = 814
// module chunks = 12